import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

interface LoaderProps {
  height?: number
  label?: string
  size?: number
}

const Loader = ({ height = 250, label = '', size = 32 }: LoaderProps) => (
  <Stack
    alignItems="center"
    gap={32}
    height={height}
    justifyContent="center"
    sx={{ backgroundColor: 'background.default' }}
  >
    <CircularProgress size={size} />
    {label && <Text>{label}</Text>}
  </Stack>
)

export default Loader
